import React, { useMemo, useRef } from 'react';
import { Form } from 'src/@vymo/ui/molecules';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import { isDesktop } from 'src/workspace/utils';
import { abcSelectFields, abcSelectFieldsGrouping } from './constants';

function ABCSelectCustomFormComponent() {
  const formRef = useRef(null);
  const config: any = {
    fields: abcSelectFields,
    formulaContext: {
      session: {},
      vo: {},
    },
  };
  const valueMap = useMemo(
    () =>
      config?.fields?.reduce((result, input) => {
        result[input.code] = { value: input.value };
        return result;
      }, {}) || {},
    [config?.fields],
  );

  return (
    <div
      style={{
        height: '100%',
        boxShadow: 'inset 0 0 4px rgba(0, 0, 0, 0.1)',
        borderRadius: 'var(--radius-l-16)',
      }}
    >
      {config?.fields?.length && (
        <Form
          // @ts-ignore
          ref={formRef}
          id="testForm"
          name="testForm"
          span={isDesktop() ? '1fr 1fr' : '1fr'}
          onChange={(formFields) => {
            // eslint-disable-next-line no-console
            console.log(formFields);
          }}
          config={{
            version: FormVersion.web,
            // @ts-ignore
            data: config.fields || [],
            grouping: abcSelectFieldsGrouping,
            fieldItemConfig: {
              showDisabledIcon: true,
            },
          }}
          value={valueMap}
          formulaContext={{
            data: {
              session: config?.formulaContext?.session || {},
              vo: config?.formulaContext?.vo || {},
            },
          }}
        />
      )}
    </div>
  );
}

export default ABCSelectCustomFormComponent;
